export const FORWARD_IMAGES_TO_PHYSICIAN = 'forward_images_to_physician'

export const FOLLOW_UP_CALL = 'follow_up_call'

export const REFINEMENT_CLARIFICATION_CALL = 'refinement_clarification_call'

export const PRINT_MODELS = 'print_models'

export const PRINT_MISSING_MODELS = 'print_missing_models'

export const PRODUCE_ALIGNER = 'produce_aligner'

export const PRODUCE_ALIGNER_EXTERNAL = 'produce_aligner_external'

export const PROVIDE_MOVEMENT_CERTIFICATE_NUMBER = 'provide_movement_certificate_number'

export const SHIP_ALIGNER = 'ship_aligner'

export const PRE_CHECK_PHOTO_CHECKIN = 'precheck_photo_checkin'

export const CHECK_PHOTO_CHECKIN = 'check_photo_checkin'

export const FINAL_CHECK_PHOTO_CHECKIN = 'final_check_photo_checkin'

export const CLARIFY_REFINEMENT = 'clarify_refinement'

export const CLARIFY_ALIGNER_CHECKIN_COMMENT = 'clarify_aligner_checkin_comment'

export const PROVIDE_CUSTOMER_COMMUNICATION_REASON = 'provide_customer_communication_reason'

export const PROVIDE_PHYSICIAN_RECOMMENDATION = 'provide_physician_recommendation'

export const SHIP_ALIGNER_EXTERNAL = 'ship_aligner_external'

export const THERMO_FORM = 'thermo_form'

export const MARKING_MODELS = 'marking_models'

export const UPLOAD_PRODUCT_FILES = 'upload_production_files'

export const CREATE_INVOICE_CORRECTION = 'create_invoice_correction'

export const PRINT_CASE_CARD = 'print_case_card'

export const REDUCER_ENAMEL = 'reduce_enamel'

export const NESTING = 'nesting'

export const NEST_MISSING_MODELS = 'nest_missing_models'

export const START_SORTING = 'start_sorting'

export const SORTING_MODELS = 'sorting_models'

export const MAKE_CUSTOMER_IPR_APPOINTMENT = 'make_customer_ipr_appointment'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/task-name.js